import { Controller } from "@hotwired/stimulus"

import L from "leaflet";
import "leaflet-draw"

// Connects to data-controller="leaflet-map"
export default class extends Controller {
  static values = {
    latitude: Number,
    longitude: Number,
    zoom: { type: Number, default: 10 }
  }

  connect() {
    if (this.map) return

    this.initializeMap()
    this.initializeLayers()
    this.initializeDrawControls()
    this.registerEvents()
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  initializeMap() {
    this.map = L.map(this.element).setView(
      [this.latitudeValue, this.longitudeValue],
      this.zoomValue
    )

    L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; OpenStreetMap contributors'
      }
    ).addTo(this.map)
  }

  initializeLayers() {
    this.drawnItems = new L.FeatureGroup()
    this.map.addLayer(this.drawnItems)
  }

  initializeDrawControls() {
    this.drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems
      },

      draw: {
        polygon: true,
        rectangle: true,
        circle: true,
        marker: true,
        polyline: false,
        circlemarker: false
      }
    })

    this.map.addControl(this.drawControl)
  }

  registerEvents() {
    this.map.on(L.Draw.Event.CREATED, (event) => {
      const layer = event.layer

      this.drawnItems.addLayer(layer)

      this.handleCreatedLayer(layer)
    })

    this.map.on(L.Draw.Event.EDITED, (event) => {
      event.layers.eachLayer((layer) => {
        this.handleEditedLayer(layer)
      })
    })

    this.map.on(L.Draw.Event.DELETED, (event) => {
      event.layers.eachLayer((layer) => {
        this.handleDeletedLayer(layer)
      })
    })
  }

  handleCreatedLayer(layer) {
    const geojson = layer.toGeoJSON()

    console.log("created", geojson)

    this.persistGeometry(geojson)
  }

  handleEditedLayer(layer) {
    const geojson = layer.toGeoJSON()

    console.log("edited", geojson)
  }

  handleDeletedLayer(layer) {
    console.log("deleted")
  }

  persistGeometry(geojson) {
    fetch("/territories", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector(
          'meta[name="csrf-token"]'
        ).content
      },

      body: JSON.stringify({
        geometry: geojson.geometry
      })
    })
  }
}
